import { point, copyPoints } from "./point.js";

export { point, copyPoints };
